import React, { useState, useEffect } from 'react'
import Faqs from '../faqs/Faqs';
import { IMG_BASE_URL } from '../../config/Base_Url_Config'
import { Link } from 'react-router-dom';
import { pricing_plan_data, user_add_to_cart } from "../../api/Product";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Web_Development_Feature = ({ data, showFaq = true }) => {
    const navigate = useNavigate();
    const [get_pricing_list, set_Pricing_List] = useState([]);
    const [active_hosting, set_Active_Hosting_Set] = useState(0);
    const development_list = data;
    const colors = ['#018EEC', '#4e8d06', '#064b8d', '#643600', '#005364', '#610064'];

    const [expandedIds, setExpandedIds] = useState(new Set());

    useEffect(() => {
        localStorage.removeItem("cart_features")
    }, [])

    const toggleExpand = (id) => {
        setExpandedIds(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    useEffect(() => {
        const handle_pricing_plan_data = async () => {
            try {
                const response = await pricing_plan_data();
                set_Pricing_List(response?.data?.pricing_plans && response?.data?.pricing_plans[0]);
            }
            catch (error) {
                console.log("error", error)
            }
        }
        handle_pricing_plan_data();
    }, [])

    const handle_add_to_cart = async (data) => {
        try {
            const formData = new FormData();
            formData.append("development_id", data);
            formData.append("quantity", "1");
            formData.append("order_type", "development");
            // <---------- User Authentciation token's ------------>
            const token = localStorage.getItem("token");
            const headers = {
                "Authorization": `Bearer ${token}`
            };
            const response = await user_add_to_cart(headers, formData);
            localStorage.setItem("add_cart_id", response?.data?.data?.id)
            if (response?.data?.status == "200") {
                // navigate("/checkout", { state: data });
                navigate("/cart");
            }
            else if (response?.response?.data?.status == "401") {
                toast.error("Please log in to access this page.")
                setTimeout(() => {
                    navigate("/login")
                }, 2000)
            }
            console.log("response", response)
        }
        catch (error) {
            console.log("error", error)
        }
    }
    return (
        <div>
            {/* <!-- Web Development Feature --> */}
            <br />
            <br />
            <section className="relative">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-light/30"></div>
                <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-blue-500/5 via-transparent to-transparent blur-2xl">
                </div>
                <div className="relative py-10 md:py-24 pt-0 sm:py-32 overflow-hidden">
                    <div className="absolute inset-0 -z-10">
                        <div className="absolute inset-0 bg-gradient-to-b from-[#fafafa] via-[#fafafa] to-[#fafafa]">
                        </div>
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px]">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-blue-600/10 blur-[120px] animate-slow-pulse">
                            </div>
                        </div>
                    </div>
                    <div className="mx-auto max-w-7xl pt-6 px-6 lg:px-8 mb-5">
                        <div className="grid grid-cols-2">
                            <div className="max-w-2xl mb-10">
                                <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-50 border border-blue-400/30 mb-2">
                                    <span className="text-sm font-medium text-blue-400"> Web Services </span>
                                </div>
                                <h2 className="text-3xl font-bold tracking-tight sm:text-4xl"><span className="sm:inline md:inline">Our
                                    Digital Services</span></h2>
                            </div>
                            <ul class="p-0 justify-end items-center mb-3 flex flex-wrap space-x-6 -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
                                <li class="me-2" >
                                    <p onClick={() => set_Active_Hosting_Set(0)} className={`inline-flex text-lg gap-2 border-b cursor-pointer hover:border-gray-300 items-center 
                                justify-center py-3 rounded-t-lg hover:text-blue-700  dark:hover:text-blue-700 group ${active_hosting == "0" ? "active text-blue-500 border-blue-500" : null}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-browser-chrome" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M16 8a8 8 0 0 1-7.022 7.94l1.902-7.098a3 3 0 0 0 .05-1.492A3 3 0 0 0 10.237 6h5.511A8 8 0 0 1 16 8M0 8a8 8 0 0 0 7.927 8l1.426-5.321a3 3 0 0 1-.723.255 3 3 0 0 1-1.743-.147 3 3 0 0 1-1.043-.7L.633 4.876A8 8 0 0 0 0 8m5.004-.167L1.108 3.936A8.003 8.003 0 0 1 15.418 5H8.066a3 3 0 0 0-1.252.243 2.99 2.99 0 0 0-1.81 2.59M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                                        </svg>
                                        Web Development
                                    </p>
                                </li>
                                <li class="me-2">
                                    <p onClick={() => set_Active_Hosting_Set(1)} className={`inline-flex text-lg gap-2 border-b cursor-pointer hover:border-gray-300 items-center 
                                justify-center py-3 rounded-t-lg hover:text-blue-700  dark:hover:text-blue-700 group ${active_hosting == "1" ? "active text-blue-500 border-blue-500" : null}`} aria-current="page">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><path clip-rule="evenodd" d="M17.1803 15.266L19.1254 14.1854C20.8399 13.2329 20.8399 10.7671 19.1254 9.81462L17.1802 8.73397L16.2071 9.70711L16.1919 9.72199L13.8148 12L16.1919 14.278L16.2071 14.2929L17.1803 15.266ZM12.3696 13.3851L14.8004 15.7146L15.362 16.2762L5.71411 21.6361C5.02468 22.0191 4.26996 22.0374 3.62199 21.7922L4.19957 21.2146L12.3696 13.3851ZM12.3696 10.6149L14.8004 8.28538L15.362 7.72381L5.71411 2.36389C5.02469 1.98088 4.26997 1.96259 3.622 2.20779L4.19957 2.78536L12.3696 10.6149ZM2.1841 3.59832L2.79289 4.20711L2.80809 4.22199L10.9243 12L2.80809 19.778L2.79289 19.7929L2.1841 20.4017C2.06606 20.1128 2 19.7931 2 19.4507V4.54928C2 4.20691 2.06606 3.88716 2.1841 3.59832Z" fill="black" fill-rule="evenodd" /></svg> App Development
                                    </p>
                                </li>

                            </ul>
                        </div>
                        <div className="relative">
                            <div className="">
                                <div className="flex transition-transform duration-500 ease-out">
                                    <div className="w-full flex-shrink-0">
                                        {
                                            active_hosting == 0 && (
                                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                                                    {development_list?.map((item, index) => {
                                                        const id = item.id ?? index;
                                                        const isExpanded = expandedIds.has(id);
                                                        {
                                                            if (item?.type == "web") {
                                                                return (
                                                                    <div key={id} className="relative group">
                                                                        <div className="relative text-center backdrop-blur-xl bg-white rounded-xl p-4 h-full border border-blue-200/10 hover:border-blue-800/50 transition-colors duration-300">
                                                                            <div className="relative shape_icon mb-8">
                                                                                <div className="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                                                    <img src={`${IMG_BASE_URL}/${item?.image}`} width="60" alt={item?.title} />
                                                                                </div>
                                                                                <svg className="size-full absolute -z-1 left-0 text-primarylight duration-1000 top-[-5px]" width="114" height="128" viewBox="0 0 114 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z"
                                                                                        fill={colors[index % colors.length]} />
                                                                                </svg>
                                                                            </div>
                                                                            <h4 className="text-[16px] hover:text-blue-700 font-bold mb-3">{item?.title}</h4>
                                                                            <p className={`text-sm text-gray-400 font-normal mb-2 transition-all duration-300 ease-in-out ${isExpanded ? '' : 'line-clamp-3'}`}>{item?.description}</p>
                                                                            <div className=" space-y-4 gap-2 justify-around mt-3">
                                                                                {/* <div className="text-blue-500 font-bold">{" "} {(index + 1) * 100} $/Hr</div> */}
                                                                                <div className="text-blue-500 font-bold">{" "} {item?.price} $</div>
                                                                                <div onClick={() => {
                                                                                    handle_add_to_cart(item?.id)
                                                                                    localStorage.setItem("cart_id", item?.id)
                                                                                    localStorage.setItem("cart_totalPrice", item?.price)
                                                                                    localStorage.setItem("cart_title", item?.title)
                                                                                    localStorage.setItem("cart_description", item?.description)
                                                                                }}>
                                                                                    <Link to="" className="text-blue-500 border-1 border-blue-500 text-sm px-10 rounded-lg py-2 hover:bg-blue-500 hover:text-white">Add to Cart</Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    })}
                                                </div>
                                            )
                                        }

                                        {
                                            active_hosting == 1 && (
                                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8">
                                                    {development_list?.map((item, index) => {
                                                        const id = item.id ?? index;
                                                        const isExpanded = expandedIds.has(id);
                                                        {
                                                            if (item?.type == "app") {
                                                                return (
                                                                    <div key={id} className="relative group">
                                                                        <div className="relative text-center backdrop-blur-xl bg-white rounded-xl p-8 h-full border border-blue-200/10 hover:border-blue-800/50 transition-colors duration-300">
                                                                            <div className="relative shape_icon mb-8">
                                                                                <div className="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                                                    <img src={`${IMG_BASE_URL}/${item?.image}`} width="60" alt={item?.title} />
                                                                                </div>
                                                                                <svg className="size-full absolute -z-1 left-0 text-primarylight duration-1000 top-[-5px]" width="114" height="128" viewBox="0 0 114 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z" fill={colors[index % colors.length]}/>
                                                                                </svg>
                                                                            </div>
                                                                            <h4 className="text-[16px] hover:text-blue-700 font-bold mb-3">{item?.title}</h4>
                                                                            <p className={`text-sm text-gray-400 font-normal mb-2 transition-all duration-300 ease-in-out ${isExpanded ? '' : 'line-clamp-3'}`}>{item?.description}</p>
                                                                            <div className="space-y-4 gap-2 justify-around mt-3">
                                                                                {/* <div className="text-blue-500 font-bold text-lg">{" "}{(index + 1) * 100} $/Hr</div> */}
                                                                                <div className="text-blue-500 font-bold text-lg">{" "}{item?.price} $</div>
                                                                                <div onClick={() => {
                                                                                    handle_add_to_cart(item?.id)
                                                                                    localStorage.setItem("cart_id", item?.id)
                                                                                    localStorage.setItem("cart_totalPrice", item?.price)
                                                                                    localStorage.setItem("cart_title", item?.title)
                                                                                    localStorage.setItem("cart_description", item?.description)
                                                                                }}>
                                                                                    <Link to="" className="text-blue-500 border-1 border-blue-500 text-sm px-10 rounded-lg py-2 hover:bg-blue-500 hover:text-white">Add to Cart</Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    })}
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <-------- FAQ'S sections ---------> */}
                   {showFaq && <Faqs />}

                </div>
            </section>
        </div>
    )
}

export default Web_Development_Feature
